import { CommercialFormValue } from '../useFinishChatForm';

export interface BotFlowInterface {
  id: number;
  name: string;
  legacy_flow_id: string;
  channel_id: number;
  actions: {
    nodes: {
      type: string;
      data: {
        action: string;
      };
    }[];
  };
}

export function getOnlyOnChatActionNode(botFlow: BotFlowInterface) {
  if (!botFlow) return null;

  // Filtra apenas os nós do tipo ACTION_ON_CHAT
  const actionOnChatNodes = botFlow.actions.nodes.filter(
    (node: any) => node.type === 'ACTION_ON_CHAT'
  );

  return {
    id: botFlow.id,
    name: botFlow.name,
    legacy_flow_id: botFlow.legacy_flow_id,
    channel_id: botFlow.channel_id,
    actions: {
      nodes: actionOnChatNodes,
    },
  };
}

export function filterBotFlow(
  botFlow: BotFlowInterface[],
  commercialType: Omit<CommercialFormValue, 'other'>,
  channel_id: number
) {
  // filtrar apenas os fluxos que possuem o tipo de ação igual ao commercialType selecionado
  return (
    botFlow.filter(
      (flow: any) =>
        flow.actions?.nodes?.[0]?.data?.action === commercialType &&
        flow.channel_id === channel_id
    ) ?? []
  );
}
